import { render, staticRenderFns } from "./frozenCardList.vue?vue&type=template&id=6aa6a1ab&scoped=true&"
import script from "./frozenCardList.vue?vue&type=script&lang=js&"
export * from "./frozenCardList.vue?vue&type=script&lang=js&"
import style0 from "./frozenCardList.vue?vue&type=style&index=0&id=6aa6a1ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa6a1ab",
  null
  
)

export default component.exports